<template>
  <div id="login" class="wrapper">
      <div class="container">
        <div class="clearfix" style="width: 100%; height: 100%;">
          <div style="float: left; width: 50%; padding: 0 20px;">
            <img src="../assets/login/logo.png" alt="" style="height: 170px; float: right;">
          </div>
          <div style="float: right; width: 50%; background-color: white; border-radius: 5px; border: solid 1px #2d8cf0; height: 100%">
            <div style="padding: 20px;">
              <Form method="POST" action="/auth/login">
                <FormItem>
                  <Input autofocus type="text" name="identity" placeholder="ID"></Input>
                </FormItem>
                <FormItem>
                  <Input type="password" name="password" placeholder="パスワード"></Input>
                </FormItem>
                <FormItem>
                  <Row>
                    <Col span="18">
                    </Col>
                    <Col span="6">
                      <Button html-type="submit" type="primary" long>ログイン</Button>
                    </Col>
                  </Row>
                  <Row>
                  </Row>
                </FormItem>
                <input type="hidden" name="to" value="/">
              </Form>
            </div>
          </div>
        </div>
      </div>
  </div>
</template>

<script>
export default {
}
</script>

<style lang="less">
html, body {
  font-family: Helvetica, Arial, sans-serif;
  height: 100%;
}

.wrapper {
  height: 100%;
  background-image: url(../assets/login/background.png);
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
}
.container {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  margin: auto;
  width: 800px;
  height: 210px;
  font-size: 16px; 
}

.clearfix:after {
  content: '';
  display: table;
  clear: both;
}

.input-block {
  margin-bottom: 30px;
}
</style>
